export default "__VITE_ASSET__CRBGYYFj__"